module.exports = __webpack_public_path__ + "_/img/icon-car.fac22c81.svg";